import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { store } from "~/Context/JukeboxContext";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faSadTear } from "@fortawesome/free-solid-svg-icons";

import styled from "styled-components";

export const MediaPlayTrackWrapper = styled.span`
  display: block;
  margin: 0 0 8px;
  text-align: inherit;

  .playPlaylistButton {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 6px 16px 6px 6px;
    border: 1px solid #d5d0ea;
    border-radius: 999px;
    background: #fff;
    color: #2c2c4a;
    font-size: 15px;
    font-weight: 600;
    line-height: 1;
    box-shadow: 0 1px 2px rgba(40, 40, 80, 0.08);
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease;

    &:hover {
      background: #f7f6fc;
      border-color: #66c;
    }
  }

  .playMark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: #66c;
    color: #fff;
    font-size: 13px;

    svg {
      margin-left: 2px;
    }
  }

  .playError {
    display: block;
    margin-top: 8px;
    color: #777;
    font-size: 13px;
    line-height: 1.3;
    text-align: inherit;
  }
`;

const JukeboxPlayArtist = ({ totalTracks = 0, artistIds = [] }) => {
  const globalState = useContext(store);
  const { dispatch } = globalState;

  const [error, setError] = useState(false);

  const playTrack = async () => {
    // await axios.get(`http://localhost:3001/playlist-artist?ids=${artistIds.join(",")}`).then(({ data }) => {
    await axios.get(`//www.dreamchimney.com/api/playlist-artist?ids=${artistIds.join(",")}`).then(({ data }) => {
      // @TODO fix type ?
      const playlist = (data && data[0]) || [];
      if (playlist && playlist.tracks && playlist.tracks.length) {
        dispatch({ type: "play_playlist", playlist: playlist });
        setError(false);
      } else {
        setError(true);
      }
    });
  };


  if (totalTracks < 2) return null;

  return (
    <MediaPlayTrackWrapper>
      <button type="button" className="playPlaylistButton" onClick={playTrack}>
        <span className="playMark">
          <FontAwesomeIcon icon={faPlay} />
        </span>
        Play Tracks
      </button>
      {error && (
        <div className="playError">
          <FontAwesomeIcon icon={faSadTear} /> None of the tracks have playable media
        </div>
      )}
    </MediaPlayTrackWrapper>
  );
};

JukeboxPlayArtist.propTypes = {
  artistIds: PropTypes.array,
};

export default JukeboxPlayArtist;
